import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { Materialize } from '~/styles/materializeGrid';
import { Label, TextArea, Input } from '~/componentes/CustomForm';

import {
  ScrollOS,
  Container,
  ButtonMenuPerfil,
  ThisCardAtvi,
  ThisCard,
  ThisCardOS,
  ThisCardTopOS,
  Content,
  TopMenu,
  Main,
  MainScroll,
  ButtonMenu,
} from './styles';

import api from '~/services/api';
import LogoErpWorks from '~/assets/logos/Logo ErpWorks.svg';
import LogoErpWorksB from '~/assets/logos/Logo ErpWorks B.svg';
import IconOrdemServico from '~/assets/icones/IconOrdemServico.svg';
import IconAnexo from '~/assets/icones/IconAnexo.svg';
import IconAtividadeOS from '~/assets/icones/IconAtividadeOS.svg';
import IconSelectiveActive from '~/assets/icones/IconSelectiveActiveBranco.svg';
import UserDevice from '~/componentes/UserDevice';

export default function OrdemServico() {
  const [ordemServico, setOrdemServico] = useState({});
  const { desktop } = UserDevice();
  let { os } = useParams();

  useEffect(() => {
    api
      .get('/unsigned/ordemservico', { params: { osHash: os } })
      .then(response => setOrdemServico(response.data));
  }, []);

  return (
    <>
      <Container desktop={desktop}>
        <Content desktop={desktop}>
          <TopMenu
            desktop={desktop}
            widthSombra={'10.6em' /*currentModulo?.menus?.length > 8 ? "10.6em" : "4.8em"*/}
          >
            <div className="sombra"></div>
            <div className="fundo-top">
              <div className="lateral-e">
                <div className="sec-logo">
                  <img
                    className="logo"
                    src={localStorage.getItem('tema') == 'E' ? LogoErpWorks : LogoErpWorksB}
                    alt="Logo"
                  />
                </div>
              </div>
              <div className="lateral-d">
                <ButtonMenu
                  onClick={() => {
                    if (localStorage.getItem('tema')) {
                      if (localStorage.getItem('tema') == 'E') {
                        localStorage.setItem('tema', 'C');
                      } else {
                        localStorage.setItem('tema', 'E');
                      }
                    } else {
                      localStorage.setItem('tema', 'E');
                    }
                    window.location.reload();
                  }}
                >
                  <img
                    src={require('~/assets/icones/IconModo' +
                      (localStorage.getItem('tema') ? localStorage.getItem('tema') : 'C') +
                      '.svg')}
                    alt={'Tema'}
                  />
                </ButtonMenu>
                <div className="cliente">
                  <div className="cliente-content">
                    <p className="cliente-titulo">{ordemServico?.cliente?.nomeFantasia}</p>
                    <p className="cliente-subtitulo">
                      {ordemServico?.projeto?.solicitante_cliente?.nome}
                    </p>
                  </div>
                </div>
                <ButtonMenuPerfil>
                  <div className="circul-perfil">
                    <p>{ordemServico?.cliente?.nomeFantasia[0]}</p>
                  </div>
                </ButtonMenuPerfil>
              </div>
            </div>
            <div className="fundo-bottom">
              <div className="os">
                <div className="os-info">
                  <img src={IconOrdemServico} alt="OS" />
                  <p className="titulo-os">OS #{ordemServico?.id}</p>
                </div>
              </div>
              <div className="navigation-menu">
                <div className="nav">{/* <img src={IconPrevAtivo} alt="Anterior" /> */}</div>
                <div className="nav">{/* <img src={IconNextDesativo} alt="Próximo" /> */}</div>
              </div>
            </div>
          </TopMenu>
          <div className={desktop ? 'body' : 'body-mobile'}>
            <Main
              desktop={desktop}
              showMenuRight={true /*currentModulo?.menus?.length > 8*/}
              autoHide
              autoHideTimeout={1000}
              autoHideDuration={500}
            >
              <MainScroll className="mainScroll">
                <ThisCard>
                  <div className="top">
                    <div className="content-top">
                      <div className="card-top">
                        <p className="titulo">{ordemServico?.projeto?.titulo}</p>
                        <p className="analista">
                          Coordenador(a): {ordemServico?.coordenador?.nome}
                        </p>
                        <p className="analista">
                          Coordenador Tecnico:{ordemServico?.coordenadorTec?.nome}
                        </p>
                      </div>
                    </div>
                    <div className="info">
                      <div className="card-cod">
                        <p className="cod">#PRJ-{ordemServico?.projeto?.id}</p>
                      </div>
                      <p className="data">{ordemServico?.dataEmissaoMascara}</p>
                    </div>
                  </div>
                  <Materialize className="padding-form">
                    <div className="row">
                      <Label className="col s12 m12 l12">
                        <TextArea
                          name="descricao"
                          defaultValue={ordemServico?.projeto?.descricaoProjeto}
                          readOnly="true"
                        />
                      </Label>
                    </div>
                  </Materialize>
                  {/* <div className="produtos">
                    <div className="card">
                      <p className="titulo-card">Anexo</p>
                    </div>
                    <div className="card">
                      <p className="titulo-card">Anexo</p>
                    </div>
                  </div>
                  <div className="card-bottom">
                    <div className="card-grupo">
                      <p className="anexo">Anexo</p>
                      <img src={IconAnexo} alt="Vazio" className="anexo-img" />
                    </div>
                  </div> */}
                </ThisCard>
                <ThisCardOS>
                  <ThisCardTopOS>
                    <div className="top">
                      <div className="content-top">
                        <div className="card-top">
                          <p className="titulo">{ordemServico?.titulo}</p>
                          <p className="analista">Analista: {ordemServico?.analista?.nome} </p>
                        </div>
                      </div>
                      <div className="info">
                        <div className="card-cod">
                          <p className="cod">#PRJ-{ordemServico?.projeto?.id}</p>
                        </div>
                        <p className="data">{ordemServico?.dataEmissaoMascara}</p>
                      </div>
                    </div>
                    <div className="totalizadores">
                      <p className="desconto">Desconto: {ordemServico?.horaDescontoMascara}</p>
                      <p className="translado">Translado: {ordemServico?.horaTransladoMascara}</p>
                      <div className="card-total">
                        <p className="total">Total: {ordemServico?.horaTotalMascara}</p>
                      </div>
                      {/* <button className="aprovar">Reprovar</button> */}
                    </div>
                  </ThisCardTopOS>
                  <div className="content-os">
                    <ScrollOS>
                      {ordemServico?.atividades?.map(e => (
                        <ThisCardAtvi key={e?.id}>
                          <div className="atividade">
                            <div className="content">
                              <div className="content-left">
                                <div className="circul-ativ">
                                  <img src={IconAtividadeOS} alt="AtivOS" />
                                </div>
                                <div className="card-top">
                                  <p className="titulo">{e?.projetoAtividade?.titulo}</p>
                                  <p className="subtitulo">Atividade</p>
                                </div>
                              </div>
                              <div className="content-right">
                                <div className="card-total">
                                  <p className="total">Total: {e?.horaTotalMascara}</p>
                                </div>
                                <div className="active">
                                  <img src={IconSelectiveActive} alt="Vazio" />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="card-bottom">
                            <p>{e?.descricao}</p>
                          </div>
                        </ThisCardAtvi>
                      ))}
                    </ScrollOS>
                  </div>
                </ThisCardOS>
              </MainScroll>
            </Main>
          </div>
        </Content>
      </Container>
    </>
  );
}
